import BaseAPIService from './baseAPI';

interface TimezoneData {
  detected_timezone: string;
  available_timezones: Record<string, string>;
}

interface UserTimezone {
  user_timezone: string;
  timezone_source: string;
}

interface TimezoneUpdateResponse {
  message: string;
  timezone: string;
}

class TimezoneAPIService extends BaseAPIService {
  constructor() {
    super();
  }

  async getAvailableTimezones(): Promise<Record<string, string>> {
    return this.get<Record<string, string>>('/timezone/available');
  }

  async detectTimezone(): Promise<TimezoneData> {
    return this.get<TimezoneData>('/timezone/detect');
  }

  async getCurrentUserTimezone(): Promise<UserTimezone> {
    return this.get<UserTimezone>('/timezone/current');
  }

  async updateTimezonePreference(timezone: string): Promise<TimezoneUpdateResponse> {
    return this.put<TimezoneUpdateResponse>('/timezone/preference', { timezone });
  }
}

export const timezoneAPI = new TimezoneAPIService();
export default timezoneAPI; 